<template>
  <label class="mobile-filter-select">
    <span>{{ picker ? label_name : (helper_text_select || label_name) }}</span>
    <select :value="picker ? '' : default_value" @change="change">
      <option v-if="picker" value="" disabled>Añadir…</option>
      <option v-for="option in options" :key="option.name" :value="option.name">{{ option.value }}</option>
    </select>
  </label>
</template>
<script>
// Mobile adapter: retain the legacy [value, field] event contract, without
// document-wide MDC selectors or delayed initialization on hidden panels.
export default {
  inheritAttrs: false,
  props: {
    options: { type: Array, default: () => [] },
    default_value: { type: [String, Number], default: '' },
    label_name: { type: String, default: '' },
    helper_text_select: { type: String, default: '' },
    component_class: { type: String, required: true },
    picker: Boolean
  },
  methods: {
    change(event) {
      this.$emit('_emit_method_order_select', [event.target.value, this.component_class]);
      if (this.picker) event.target.value = '';
    }
  }
};
</script>
